import Statistics from './Statistics/Statistics'
import ObjectsList from './ObjectsList/ObjectsList'

export { Statistics, ObjectsList }
